import { setGlobalTheme } from '@atlaskit/tokens';
import type { Theme } from '@atlassian/jira-common-constants/src/theme-preference.tsx';
/**
 * Ensures the application's theme aligns with user preferences by loading and applying theme tokens. This function is designed to run in a client-side environment and adapts the visual style according to selected themes, including support for legacy typography settings under certain conditions.
 */
export const loadThemeTokens = async (theme: Theme) => {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}
	if (['light', 'dark', 'auto'].includes(theme)) {
		await setGlobalTheme({
			colorMode: theme,
		});
	}
};
